import React from "react";
import moment from "moment-timezone";

export default function AdminChatList({ chats, selectedChat, onSelectChat, participants, searchTerm, setSearchTerm, onLoadMore, isLoading }) {
    const handleScroll = (e) => {
        const { scrollTop, clientHeight, scrollHeight } = e.target;
        if (scrollHeight - scrollTop <= clientHeight + 50) {
            if (onLoadMore) onLoadMore();
        }
    };

    return (
        <div className="col-md-4 mailbox-list d-flex flex-column" style={{ height: '80vh' }}>
            <div className="p-3 border-bottom bg-white">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search by name or email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            <div className="flex-grow-1" style={{ overflowY: 'auto' }} onScroll={handleScroll}>
                <h5 className="p-3">All Conversations ({chats.length})</h5>
                {isLoading && <div className="text-center p-2 text-muted">Searching entire database...</div>}
                <ul className="list-unstyled">
                    {chats.map((chat) => {
                        const lastMessage = chat.messages ? chat.messages[chat.messages.length - 1] : null;
                        const participantNames = participants[chat.chatId]?.names || "Loading...";

                        return (
                            <li
                                key={chat.chatId}
                                className={`p-3 border-bottom`}
                                onClick={() => onSelectChat(chat)}
                                style={{
                                    cursor: 'pointer',
                                    backgroundColor: selectedChat?.chatId === chat.chatId ? '#e8f4fd' : 'transparent',
                                    borderLeft: selectedChat?.chatId === chat.chatId ? '4px solid #007bff' : 'none'
                                }}
                            >
                                <div className="d-flex justify-content-between">
                                    <strong className="text-truncate" style={{ maxWidth: '70%' }} title={participantNames}>
                                        {participantNames}
                                    </strong>
                                    <small className="text-muted">
                                        {lastMessage && moment(lastMessage.timestamp).fromNow()}
                                    </small>
                                </div>
                                <p className="text-muted mb-0 text-truncate" style={{ maxWidth: '250px' }}>
                                    {lastMessage?.message || "No messages"}
                                </p>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    );
}
